import React, { useState } from 'react'
import $ from "jquery";


const Logo = ({ data, ShowSidebar }) => {

    const [togglesidebar, settogglesidebar] = useState(false)
   
    if (togglesidebar) {
        $('#root').addClass("menu-toggle")
    } else {
        $('#root').removeClass("menu-toggle")
    }


    return (
        <div>
            <div className="nav-header d-flex align-items-center">
                <span className="brand-logo">
                    {togglesidebar ? 
                   <div> <img className="logo-abbr1" style={{width:"48px"}} src={data ? data : ""} alt="logo" />
                  </div> :
                     <img className="brand-title" src={data ? data : ""} alt="logo" />}
             

                </span>


                
            </div>
        </div>
    )
}

export default Logo